export enum LeadLostReasonEnum {
  PRECO = 'PRECO',
  AGENDA = 'AGENDA',
  CONCORRENTE = 'CONCORRENTE',
  SEM_RETORNO = 'SEM_RETORNO',
  DESISTIU = 'DESISTIU',
  OUTRO = 'OUTRO',
}

export const LEAD_LOST_REASON_VALUES: LeadLostReasonEnum[] = [
  LeadLostReasonEnum.PRECO,
  LeadLostReasonEnum.AGENDA,
  LeadLostReasonEnum.CONCORRENTE,
  LeadLostReasonEnum.SEM_RETORNO,
  LeadLostReasonEnum.DESISTIU,
  LeadLostReasonEnum.OUTRO,
];
